<template>
  <Card style="padding: 0px" class="overflow-hidden">
    <router-link :to="routerLink">
      <img
        v-if="categoryImage?.length"
        :class="['category-image', !freeHeight ? 'max-h-32' : '']"
        :src="categoryImage"
      />

      <content-placeholders
        class="category-image w-full"
        v-else-if="!categoryImage?.length && hasProduct"
      >
        <content-placeholders-img />
      </content-placeholders>

      <div class="flex flex-col justify-between h-full" v-if="!hasProduct">
        <div
          class="bg-gray-200 text-sm text-gray-400 h-full p-5 text-center flex flex-col justify-center"
        >
          <i>No products available...</i>
        </div>
        <h4 class="px-3">
          {{ category.name[language] }}
        </h4>
      </div>

      <h4 v-else class="px-3">
        {{ category.name[language] }}
      </h4>
    </router-link>
  </Card>
</template>

<script>
import api from "@/helpers/api";
import Card from "../UI/Card.vue";
import { getCategoryPath } from "@/helpers/categories";

export default {
  name: "CategoryCard",
  components: { Card },
  props: {
    category: {
      type: Object,
    },
    language: {
      type: String,
      default: "en",
    },
    freeHeight: Boolean,
  },
  data() {
    return {
      tempCategoryImage: null,
      defaultCategoryImage: null,
      hasProduct: true,
    };
  },
  methods: {
    async getDefaultCategoryImage() {
      try {
        const data = await api.post("/products/filter", {
          categoryIdentifier: [this.category.identifier],
        });

        const id = data.productIds[0];
        const { products } = await api.post("/products", [id]);

        if (!products.length) {
          this.hasProduct = false;
        }

        this.defaultCategoryImage =
          products[0].mime[0].mimeSource[this.language];
      } catch (e) {
        console.log(e);
      }
    },
    getSubcategories() {
      const identifier = this.category.identifier;
      const cat = this.categoryPath?.find(
        (category) => category.identifier == identifier
      );

      if (!cat) return [];

      return cat?.subcategories || [];
    },
  },
  computed: {
    categoryImage() {
      return (
        this.category?.www?.[0]?.imageUrl?.[this.language] ||
        this.defaultCategoryImage
      );
    },

    categoryPath() {
      const identifier = this.category.identifier;
      const path = getCategoryPath(
        identifier,
        this.language,
        this.$store.getters.categoryTree
      );

      return path;
    },

    subcategories() {
      return this.getSubcategories();
    },
    routerLink() {
      if (this.subcategories.length) {
        return `/category/${this.category.identifier}?lang=${this.language}`;
      }

      return `/category-product/${this.category.identifier}?lang=${this.language}`;
    },
  },
  mounted() {
    if (!this.categoryImage) {
      this.getDefaultCategoryImage();
    }
  },
};
</script>

<style></style>
